<template>
  <ul>
    <li v-for="item in items" :key="item.id">
      <MenuLateralItem :item="item" />
    </li>
    <li style="margin-bottom: 200px" />
  </ul>
</template>

<script>
import MenuLateralItem from './MenuLateralItem'

export default {
  name: 'MenuLateral',
  components: { MenuLateralItem },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
}
</script>
